import queries from './query/States';

export const StatesSchema = {
  queries,
};
